/**
 * @generated SignedSource<<98f9a734edf70bde6840fb8b3371a6af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedHeroCarousel_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemTilesCarouselModule_user">;
  readonly " $fragmentType": "HpSharedHeroCarousel_user";
};
export type HpSharedHeroCarousel_user$key = {
  readonly " $data"?: HpSharedHeroCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedHeroCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedHeroCarousel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedItemTilesCarouselModule_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "267a66a4af14f7481fc988871ff64c71";

export default node;
